// Create mode and form actions
export const SET_ACTIVE_MODE = 'SET_ACTIVE_MODE'
export const SET_SELECTED_MODEL = 'SET_SELECTED_MODEL'
export const SET_SELECTED_MODEL_PRESERVE_DATA = 'SET_SELECTED_MODEL_PRESERVE_DATA'

// Form state persistence actions
export const SAVE_FORM_STATE_FOR_MODE = 'SAVE_FORM_STATE_FOR_MODE'
export const RESTORE_FORM_STATE_FOR_MODE = 'RESTORE_FORM_STATE_FOR_MODE'

export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'

// Generation actions - Old single generation system (kept for compatibility)
export const START_GENERATION = 'START_GENERATION'
export const UPDATE_GENERATION_PROGRESS = 'UPDATE_GENERATION_PROGRESS'
export const GENERATION_SUCCESS = 'GENERATION_SUCCESS'
export const GENERATION_FAILED = 'GENERATION_FAILED'
export const RESET_GENERATION = 'RESET_GENERATION'

// New Queue-based Generation actions
export const ADD_TO_GENERATION_QUEUE = 'ADD_TO_GENERATION_QUEUE'
export const UPDATE_QUEUE_ITEM_PROGRESS = 'UPDATE_QUEUE_ITEM_PROGRESS'
export const COMPLETE_QUEUE_ITEM = 'COMPLETE_QUEUE_ITEM'
export const FAIL_QUEUE_ITEM = 'FAIL_QUEUE_ITEM'
export const REMOVE_FROM_GENERATION_QUEUE = 'REMOVE_FROM_GENERATION_QUEUE'
export const SELECT_QUEUE_ITEM = 'SELECT_QUEUE_ITEM'
export const CLEAR_QUEUE_SELECTION = 'CLEAR_QUEUE_SELECTION'
export const RETRY_QUEUE_ITEM = 'RETRY_QUEUE_ITEM'

// Validation actions
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS'
export const CLEAR_VALIDATION_ERRORS = 'CLEAR_VALIDATION_ERRORS'

// UI actions
export const SET_SIDEBAR_EXPANDED = 'SET_SIDEBAR_EXPANDED'
export const TOGGLE_SIDEBAR_SWAP = 'TOGGLE_SIDEBAR_SWAP'

// Gallery/Deployment actions
export const FETCH_GALLERY_REQUESTED = 'FETCH_GALLERY_REQUESTED'
export const FETCH_GALLERY_SUCCESS = 'FETCH_GALLERY_SUCCESS'
export const FETCH_GALLERY_FAILED = 'FETCH_GALLERY_FAILED'
export const RESET_GALLERY = 'RESET_GALLERY'
export const SET_GALLERY_VIEW_MODE = 'SET_GALLERY_VIEW_MODE'
export const SET_GALLERY_FILTER = 'SET_GALLERY_FILTER'

// Gallery item selection actions
export const SELECT_GALLERY_ITEM = 'SELECT_GALLERY_ITEM'
export const CLEAR_GALLERY_SELECTION = 'CLEAR_GALLERY_SELECTION'

// Add generated result to gallery cache
export const ADD_RESULT_TO_GALLERY_CACHE = 'ADD_RESULT_TO_GALLERY_CACHE'
